import { render, staticRenderFns } from "./CallInfoModal.vue?vue&type=template&id=0dffcc74&"
import script from "./CallInfoModal.vue?vue&type=script&lang=js&"
export * from "./CallInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports